import React, {useEffect, useRef, useState} from "react";
import {toast} from 'react-toastify';
import EditableTable from "../../../primer/Editable-Table";
import {Accordion, Button, Col, Row, Form} from 'react-bootstrap';
import Dropdown from "../../../primer/Dropdown";
import {useDispatch, useSelector} from "react-redux";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {
    newProductsCategoryMyDataInitialValue,
    setNewProductsCategoryMyData
} from "../../../../_reducers/DataPanel/Products/productCategorySlice";
import getMyData, {
    getICCategoryOptions,
    getICTypeOptions,
    getInvoiceTypesOptions, getMyDataRowTypes, getVatExpenseClassificationType
} from '../../../../_helpers/sharedmydata';
import {
    newAccountingAccountCategoryInitialValue, setAccountingPaymentTypes,
    setAccountingSettings, setF2AccordionActiveKeys,
    setF2ClassicRules, setF2AccountingRecordCreationRules, setF2RulesInitialFetchDone
} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {
    fetchAccountingPaymentTypes,
    fetchAccountingRecordCategories, fetchAccountingRecordSubcategories,
    postAccountingSettings
} from "../../../../_apis/api";
import {
    checkPermission,
    getDefaultOptionByValue,
    getIsNetValueOptions, getOptionsByData,
    getSubaccountOptions, getTaxTypeOptions, isEmpty,
    resetTableItemsId, validateAFM
} from "../../../../_helpers/commonFunctions";
import {salesPaymentTypeData} from "../../../../_data/sales/sales-payment-types";
import {setSaveAccountingPaymentTypes} from "../../../../_reducers/activitySlice";
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import LogTable from "../../../primer/LogTable";
import Input from "../../../common/Input";
import {useTranslation} from "../../../../hooks/useTranslation";

export const AccountingAccountSettings = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const invoiceTypes = getInvoiceTypesOptions();
    const icCategory = getICCategoryOptions();
    const icType = getICTypeOptions();
    const myDataRowTypes = getMyDataRowTypes();
    const vatExpenseTypes = getVatExpenseClassificationType();
    const isNetValueOptions = getIsNetValueOptions();
    const subAccountOptions = getSubaccountOptions();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const newProductsCategoryMyData = useSelector(state => state.PRODUCTS_CATEGORY.newProductsCategoryMyData);
    const accountingCategories = useSelector((state) => state.ACCOUNTING_DATA.accountingCategories);
    const vatTaxes = [{value: "", label: t("Null")}, ...getMyData({type: 'vat', option: "doNotShowZero"})];
    const taxTypeOptions = getTaxTypeOptions();
    const zeroVatReason = getMyData({type: 'zerovatreason'});
    const SETTINGS = useSelector(state => state.SETTINGS);
    let pMDDSettings = SETTINGS.primerMyDataData;
    let otherTaxes = getOptionsByData(pMDDSettings?.otherTaxes !== undefined && pMDDSettings?.otherTaxes !== '' ? (pMDDSettings.otherTaxes) : SETTINGS.otherHoldTaxes, 'code', 'name');
    let taxesWithhold = getOptionsByData(pMDDSettings?.withHoldTaxes !== undefined && pMDDSettings?.withHoldTaxes !== '' ? (pMDDSettings.withHoldTaxes) : SETTINGS.withHoldTaxes, 'code', 'name');
    let taxesStamp = getOptionsByData(pMDDSettings?.stamp !== undefined && pMDDSettings?.stamp !== '' ? (pMDDSettings.stamp) : SETTINGS.stamp, 'code', 'name');
    let taxesFees = getOptionsByData(pMDDSettings?.fees !== undefined && pMDDSettings?.fees !== '' ? (pMDDSettings.fees) : SETTINGS.fees, 'code', 'name');
    // Fix Blank In the first position
    otherTaxes = [{value: "", label: t("Null"), color: "#76AEB7"}, ...otherTaxes]
    taxesWithhold = [{value: "", label: t("Null"), color: "#76AEB7"}, ...taxesWithhold]
    taxesStamp = [{value: "", label: t("Null"), color: "#76AEB7"}, ...taxesStamp]
    taxesFees = [{value: "", label: t("Null"), color: "#76AEB7"}, ...taxesFees]

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const productsColumns = [
        {
            name: t('ProductsNewGeneral.table.rowType'),
            field: "rowType",
            width: "10%",
            editable: true,
            inputType: {
                type: 'select',
                options: myDataRowTypes
            }
        },
        {
            name: t('ProductsSettings.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            width: "30%",
            inputType: {
                type: 'select',
                multiselect: true,
                options: invoiceTypes
            }
        },
        {
            name: t('ProductsSettings.table.category'),
            field: "category",
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: icCategory
            }
        },
        {
            name: t('ProductsSettings.table.type'),
            field: 'type',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: icType
            }
        },
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: 'vatExpenseType',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: vatExpenseTypes,
            }
        }
    ];
    const accountingCategoryColumns = [
        {
            name: t("General.templateAccountName"),
            field: "category",
            width: "100%",
            disabled: false,
            editable: true,
            inputType: {
                type: 'text',
            }
        }
    ];
    const [editing, setEditing] = useState(false);
    const [forceRender, setForceRender] = useState(0);
    const [showZeroVatReson, setShowZeroVatReson] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState({});
    const [showExtraDetails, setShowExtraDetails] = useState(false);

    useEffect(() => {
        setForceRender(0);
        if ((selectedCategory.vat === '0%') || (selectedCategory.vat === '0')) {
            setShowZeroVatReson(true);
        } else {
            setShowZeroVatReson(false);
        }
    }, [dispatch, forceRender]);

    // Show 0% VAT Reason
    const toggleVatReasonField = (e) => {
        if ((e.value === '0')) {
            setShowZeroVatReson(true);
        } else {
            setShowZeroVatReson(false);
        }
    }

    const handleOnFieldChange = (e, name = '', inputType = '') => {
        setEditing(true);
        setForceRender(forceRender + 1)
        let accountingCategory = Object.assign({}, selectedCategory);
        if (inputType === 'ac' || inputType === 'dd') {
            accountingCategory[name] = e.value;
            if (name === 'isNetValue') {
                toggleVatReasonField(e);
                if (e.value !== "0") {
                    accountingCategory["vatreason"] = "";
                }
            }
        }
        setSelectedCategory({...accountingCategory});
    }

    const handleSaveCategory = async () => {
        if (editing) {
            // In case of updating existing category
            if ((Object.keys(selectedCategory).length !== 0)) {
                let saveCategory = Object.assign({}, selectedCategory);
                saveCategory.id = saveCategory._id;
                if ((Object.keys(selectedCategory).length !== 0)) {
                    let categories = accountingCategories.slice();
                    await Promise.all(categories.map((category, index) => {
                        if (category._id === selectedCategory._id) {
                            categories[index] = selectedCategory;
                        }
                        return category;
                    }))
                    dispatch(setAccountingSettings(categories));
                    dispatch(postAccountingSettings({categories: categories}, {company: company.id}));
                }
                setEditing(false);
                setForceRender(forceRender + 1)
            }
        }
    }


    const parentActions = {
        insert: (e, data) => {
            setForceRender(forceRender + 1)
            const newAccountingAccountCategory = Object.assign({}, newAccountingAccountCategoryInitialValue);
            if (data?.category !== "") {
                newAccountingAccountCategory[data.field] = data.value;
                let tempCategoryData = accountingCategories.slice();
                newAccountingAccountCategory._id = accountingCategories.length + 1;
                newAccountingAccountCategory.isActive = "active";
                tempCategoryData.push(newAccountingAccountCategory);
                dispatch(setAccountingSettings(tempCategoryData));
                dispatch(postAccountingSettings({categories: tempCategoryData}, {company: company.id}));
                setSelectedCategory(newAccountingAccountCategory);
                setShowExtraDetails(true);

            } else {
                toast.error("Please enter category name");
            }
        },
        selected: (data) => {
            if (editing) {
                toast.warning('Please save your changes.');
            } else {
                if (data && typeof (data._id) !== 'undefined') {
                    const selected = getObjectFromArrayOfObjects(accountingCategories, data._id, '_id')['0'];
                    setSelectedCategory(selected);
                    // Set Proposed My Data for selected category
                    if ((Object.keys(selected).length !== 0)) {
                        try {
                            const vat = selected.vat;
                            if ((vat === '0%') || (vat === '0')) {
                                setShowZeroVatReson(true);
                            } else {
                                setShowZeroVatReson(false);
                            }
                        } catch (e) {
                            console.log('taxes is not an json object');
                        }
                    }
                    setShowExtraDetails(true);
                } else {
                    setShowExtraDetails(false);
                }
            }
        },
        update: async (data, id) => {
            setForceRender(forceRender + 1);
            if (data?.name === '') {
                toast.error('Category name should not be empty.');
            } else {
                let tempCategoryData = accountingCategories.slice();
                if (tempCategoryData) {
                    const objindx = tempCategoryData.findIndex(obj => obj._id === id);
                    let catObj = tempCategoryData[objindx];
                    setSelectedCategory(catObj);
                    tempCategoryData[objindx] = {...catObj, ...data};
                    dispatch(setAccountingSettings(tempCategoryData));
                    dispatch(postAccountingSettings({categories: tempCategoryData}, {company: company.id}));
                }
            }
        },
        delete: (id) => {
            let tempCategoryData = accountingCategories.slice();
            let deleteCategory = getObjectFromArrayOfObjects(tempCategoryData, id, '_id')['0'];
            const objindx = tempCategoryData.findIndex(obj => obj._id === id);
            tempCategoryData[objindx] = {...deleteCategory, ...{id: id, isActive: 'inactive', deleted: true}};
            dispatch(setAccountingSettings(tempCategoryData));
            dispatch(postAccountingSettings({categories: tempCategoryData}, {company: company.id}));
        }
    }
    const parentMydataActions = {
        insert: (e, data) => {
            setEditing(true);
            setForceRender(forceRender + 1)
            let tempPcMyData = Object.assign({}, newProductsCategoryMyData);
            if (e.key !== "Enter") {
                tempPcMyData[data.field] = data.value;
                dispatch(setNewProductsCategoryMyData(tempPcMyData)); // Update redux my data values
            }
            // If validated fields done add new row
            if (tempPcMyData.rowType !== '' && tempPcMyData.invoiceType !== '' && tempPcMyData.category !== '' && tempPcMyData.type !== '') {
                let updateNewPcMydata = Object.assign({}, newProductsCategoryMyData);
                updateNewPcMydata.id = selectedCategory.mydata.length + 1;
                // set the last updated value
                if (tempPcMyData.type) {
                    updateNewPcMydata.type = tempPcMyData.type;
                }
                if (tempPcMyData.rowType) {
                    updateNewPcMydata.rowType = tempPcMyData.rowType;
                }
                if (tempPcMyData.invoiceType) {
                    updateNewPcMydata.invoiceType = tempPcMyData.invoiceType;
                }
                if (tempPcMyData.category) {
                    updateNewPcMydata.category = tempPcMyData.category;
                }
                let accountingCategory = Object.assign({}, selectedCategory);
                let updatedMyData = Array.isArray(accountingCategory.mydata) ? [...accountingCategory.mydata, updateNewPcMydata] : [updateNewPcMydata];
                setSelectedCategory({...accountingCategory, mydata: updatedMyData});
                dispatch(setNewProductsCategoryMyData(newProductsCategoryMyDataInitialValue)); // Reset new category mydata
            }
        },
        update: (data, id) => {
            setEditing(true);
            setForceRender(forceRender + 1)
            let selectedCategoryMyData = Object.assign([], selectedCategory.mydata);
            if (selectedCategoryMyData.find(item => item.id === id) !== undefined) {
                let accountingCategory = Object.assign({}, selectedCategory);
                selectedCategoryMyData[id - 1] = {...selectedCategoryMyData[id - 1], ...data};
                if (data.invoiceType) {
                    selectedCategoryMyData[id - 1].category = "";
                    selectedCategoryMyData[id - 1].type = "";
                    selectedCategoryMyData[id - 1].vatExpenseType = "";
                } else if (data.category) {
                    selectedCategoryMyData[id - 1].type = "";
                    selectedCategoryMyData[id - 1].vatExpenseType = "";
                } else if (data.type) {
                    selectedCategoryMyData[id - 1].vatExpenseType = "";
                }
                setSelectedCategory({...accountingCategory, mydata: selectedCategoryMyData});
            }
        },
        selected: () => {
        },
        delete: (id) => {
            let oldMydata = Object.assign([], selectedCategory.mydata);
            setEditing(true);
            setForceRender(forceRender + 1)
            if (id > 0) {
                oldMydata.splice(id - 1, 1);
                oldMydata = resetTableItemsId(oldMydata);
                let accountingCategory = Object.assign({}, selectedCategory);
                setSelectedCategory({...accountingCategory, mydata: oldMydata});
                toast.success('1 row deleted.');
            }
        }
    }
    return (
        <>
            <div className="row">
                <div className="col-lg-6">
                    <div className="product-categories">
                        <EditableTable
                            tableName="Accounting Category" // Do not change name
                            selectedRow={selectedCategory._id}
                            onUpdate={parentActions}
                            key={Math.random()}
                            allowActions={true}
                            actionButtons={{
                                print: false,
                                delete: true,
                                export: false,
                                edit: false,
                            }}
                            allowInsertRow={true}
                            data={accountingCategories && accountingCategories.length > 0 ? accountingCategories : []}  // Default Category
                            columns={accountingCategoryColumns}
                        />
                    </div>
                </div>
                <div className="col-lg-6 ">
                    <p className="text-muted"><i>{t('AccountingAccountSettings.description')}</i></p>
                </div>
            </div>
            {/* Category Extra Details */}
            {showExtraDetails ?
                <>
                    <br/>
                    <p className="text-center border-bottom pb-3 pt-3 "><i>{t('ProductsSettings.categorySettings')}</i>
                    </p>
                    <div className="row">
                        <div className="col-12">
                            <p className="text-muted"><i>{t('ProductsSettings.proposedMyDataValue')}</i></p>
                            <EditableTable
                                tableName="Product Category My Data" // Do not change name
                                key={Math.random()}
                                onUpdate={parentMydataActions}
                                allowActions={true}
                                allowInsertRow={true}
                                columns={productsColumns}
                                data={selectedCategory?.mydata ? selectedCategory?.mydata : []}
                                enableNewRowCheckbox={true}
                            />
                        </div>
                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-12">
                            <p className="text-muted"><i>Άλλες Ρυθμίσεις</i></p>
                        </div>
                        {selectedCategory.vat === "" && selectedCategory.taxType === "" && (
                            <div className="col-lg-4">
                                <Dropdown
                                    defaultValue={getDefaultOptionByValue(isNetValueOptions, selectedCategory.isNetValue, 'value', 'label', 'value')}
                                    key={Math.random()}
                                    label={t("General.isNetValue")}
                                    onChange={(e) => handleOnFieldChange(e, 'isNetValue', 'dd')}
                                    options={isNetValueOptions}
                                />
                            </div>
                        )}
                        {showZeroVatReson &&
                            <div className="col-lg-4">
                                <Dropdown
                                    defaultValue={{
                                        value: selectedCategory.vatreason,
                                        label: selectedCategory.vatreason,
                                        color: "#76AEB7"
                                    }}
                                    key={Math.random()}
                                    label={t('ProductsSettings.0%vatReason')}
                                    onChange={(e) => handleOnFieldChange(e, 'vatreason', 'dd')}
                                    options={zeroVatReason}
                                />
                            </div>
                        }
                        {selectedCategory.isNetValue === "false" && selectedCategory.taxType === "" && (
                            <div className="col-lg-4">
                                <Dropdown
                                    key={Math.random()}
                                    defaultValue={{value: selectedCategory.vat, label: selectedCategory.vat}}
                                    onChange={(e) => handleOnFieldChange(e, 'vat', 'dd')}
                                    label={t('ProductsSettings.vat%')}
                                    options={vatTaxes}
                                />
                            </div>
                        )}
                        {selectedCategory.isNetValue === "false" && selectedCategory.vat === "" &&
                            <div className="col-lg-4">
                                <Dropdown
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(taxTypeOptions, selectedCategory.taxType, 'value', 'label', 'value')}
                                    onChange={(e) => handleOnFieldChange(e, 'taxType', 'dd')}
                                    label={t("General.isTax")}
                                    options={taxTypeOptions}/>
                            </div>
                        }
                        {selectedCategory.taxType === "withHoldTax" &&
                            <div className="col-lg-4">
                                <Dropdown
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(taxesWithhold, selectedCategory.withHoldTax, 'value', 'label', 'value')}
                                    onChange={(e) => handleOnFieldChange(e, 'withHoldTax', 'dd')}
                                    required={true}
                                    label={t("General.taxWithholding")}
                                    options={taxesWithhold}
                                />
                            </div>
                        }
                        {selectedCategory.taxType === "otherTax" &&
                            <div className="col-lg-4">
                                <Dropdown
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(otherTaxes, selectedCategory.otherTax, 'value', 'label', 'value')}
                                    onChange={(e) => handleOnFieldChange(e, 'otherTax', 'dd')}
                                    required={true}
                                    label={t("General.otherTax")}
                                    options={otherTaxes}
                                />
                            </div>
                        }
                        {selectedCategory.taxType === "fee" &&
                            <div className="col-lg-4">
                                <Dropdown
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(taxesFees, selectedCategory.fee, 'value', 'label', 'value')}
                                    onChange={(e) => handleOnFieldChange(e, 'fee', 'dd')}
                                    required={true}
                                    label="Τέλος"
                                    options={taxesFees}
                                />
                            </div>
                        }
                        {selectedCategory.taxType === "stamp" &&
                            <div className="col-lg-4">
                                <Dropdown
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(taxesStamp, selectedCategory.stamp, 'value', 'label', 'value')}
                                    onChange={(e) => handleOnFieldChange(e, 'stamp', 'dd')}
                                    required={true}
                                    label="Χαρτόσημο (Ψηφ. τέλος συν.)"
                                    options={taxesStamp}
                                />
                            </div>
                        }
                        <Row>
                            <div className="col-lg-4">
                                <Dropdown
                                    defaultValue={getDefaultOptionByValue(subAccountOptions, selectedCategory.subAccount, 'value', 'label', 'value')}
                                    key={Math.random()}
                                    label="Υπολογαριασμός"
                                    onChange={(e) => handleOnFieldChange(e, 'subAccount', 'dd')}
                                    options={subAccountOptions}
                                />
                            </div>
                        </Row>
                    </div>
                </>
                : ''}
            <div className="d-flex justify-content-end">
                {checkPermission("accounting-settings/accounting-settings-write", permissionsData) &&
                    <Button disabled={!editing} onClick={(e) => handleSaveCategory(e)}
                            className="ml-2 mb-3">{t('ProductsSettings.save')}</Button>
                }
            </div>
        </>
    );
};

export const AccountingPaymentMethods = () => {
    const dispatch = useDispatch();
    const paymentTypes = useSelector((state) => state.ACCOUNTING_DATA.paymentTypes);
    const saveAccountingPaymentTypes = useSelector((state) => state.ACTIVITY.saveAccountingPaymentTypes);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [firstLoad, setFirstLoad] = useState(true);
    const {t} = useTranslation();

    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
            dispatch(fetchAccountingPaymentTypes(company));
        }
    }, [firstLoad])

    const paymentTypesColumns = [
        {
            name: t("General.no"),
            field: "no",
            editable: false,
        },
        {
            name: t("General.name"),
            field: "name",
            editable: true,
            inputType: {
                type: "text"
            }
        },
        {
            name: t("General.type"),
            field: "type",
            editable: true,
            width: "200px",
            inputType: {
                type: "dropdown",
                options: getOptionsByData(salesPaymentTypeData, "value", "label"),
            }
        }
    ]

    const paymentTypesActions = {
        insert: (e, data) => {
            if (e.key !== "Enter" && String(data.value) !== "") {
                let ptTypes = paymentTypes.slice();
                let newPaymentType = {
                    no: String(ptTypes.length + 1),
                    id: String(ptTypes.length + 1),
                }
                if (data.field === "type") {
                    newPaymentType.myDataPaymentId = salesPaymentTypeData.filter((el) => el.value === data.value)[0].myDataId;
                }
                newPaymentType[data.field] = data.value;
                ptTypes.push(newPaymentType);
                dispatch(setAccountingPaymentTypes(ptTypes));
                if (!saveAccountingPaymentTypes) dispatch(setSaveAccountingPaymentTypes(true));
            }
        },
        update: (data, id) => {
            let ptTypes = paymentTypes.slice();
            ptTypes = ptTypes.map((a) => Object.assign({}, a));
            let idx = ptTypes.findIndex((el) => String(el.id) === String(id));
            if (idx !== -1) {
                ptTypes[idx] = {...ptTypes[idx], ...data}
                if (data.type) {
                    ptTypes[idx] = {
                        ...ptTypes[idx],
                        myDataPaymentId: salesPaymentTypeData.filter((el) => el.value === data.type)[0].myDataId
                    }
                }
                dispatch(setAccountingPaymentTypes(ptTypes));
                if (!saveAccountingPaymentTypes) dispatch(setSaveAccountingPaymentTypes(true));
            }
        },
        selected: () => {
        },
        delete: () => {
        }
    }

    const handleSaveClicked = () => {
        axios.post(process.env.REACT_APP_API_URL2 + "/accounting/save-payment-types", {
            company: company.id,
            paymentTypes: paymentTypes
        }, {headers: {"Content-Type": "application/json"}})
            .then((response) => {
                if (response.data.status === "200") {
                    toast.success(response.data.message);
                    dispatch(setSaveAccountingPaymentTypes(false));
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch((err) => {
                toast.error("Σφάλμα κατά την αποθήκευση.");
                console.log(err);
            })
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={6}>
                    <EditableTable
                        tableName={"Accounting Settings Payment Types"}
                        data={paymentTypes}
                        columns={paymentTypesColumns}
                        onUpdate={paymentTypesActions}
                        key={Math.random()}
                        allowInsertRow={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col className={"d-flex justify-content-end"}>
                    <Button onClick={() => handleSaveClicked()} className={"mb-3"}
                            disabled={!saveAccountingPaymentTypes}>Αποθήκευση</Button>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export const AccountingYearReportSettings = () => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const {t} = useTranslation();

    useEffect(() => {
        fetchRules();
    }, [])

    const tableColumns = [
        {
            name: t("General.no"),
            field: "no",
            editable: false,
            width: "5%"
        },
        {
            name: t("General.ruleName"),
            field: "ruleName",
            editable: true,
            width: "25%",
            inputType: {
                type: "input"
            }
        },
        {
            name: t("General.rules"),
            field: "rules",
            editable: true,
            width: "55%",
            inputType: {
                type: "input"
            }
        },
        {
            name: "Πρόσημο",
            field: "sign",
            editable: true,
            width: "15%",
            inputType: {
                type: "select",
                options: [{label: "Πίστωση", value: "credit"}, {label: "Χρέωση", value: "debit"}]
            }
        }
    ]
    const fetchRules = () => {
        setLoading(true);
        axios.get(process.env.REACT_APP_API_URL2 + "/accounting/get-yearly-results-rules", {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                setTableData(res.data.data);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
        })
    }
    const handleSave = () => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/accounting/save-yearly-results-rules", {
            company: company.id,
            yearlyResultsRules: tableData
        }, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Η αποθήκευση έγινε επιτυχώς.");
            } else {
                toast.success(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }
    const tableFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value)) {
                let cloneTableData = structuredClone(tableData);
                let initRow = {
                    no: String(tableData.length + 1),
                    ruleName: "",
                    rules: "",
                    sign: "credit",
                }
                initRow = {...initRow, [data.field]: data.value};
                cloneTableData.push(initRow);
                setTableData(cloneTableData);
            }
        },
        update: (data, id, rowIndex) => {
            let cloneTableData = structuredClone(tableData);
            cloneTableData[rowIndex] = {...cloneTableData[rowIndex], ...data};
            setTableData(cloneTableData);
        },
        selected: () => {
        },
        delete: (id, rowIndex) => {
            let cloneTableData = structuredClone(tableData);
            cloneTableData.splice(rowIndex, 1);
            setTableData(cloneTableData);
        }
    }

    return (
        <React.Fragment>
            <Row>
                <div className="text-muted mb-1"><i>Κανόνες Ετησίων Αποτελεσμάτων</i></div>
                <Col md={12}>
                    <EditableTable
                        tableName={"Accounting Yearly Results"}
                        key={Math.random()}
                        data={tableData}
                        columns={tableColumns}
                        onUpdate={tableFunctions}
                        allowInsertRow={true}
                        allowActions={true}
                    />
                    <Button size={"sm"} style={{float: "right"}} onClick={() => handleSave()}
                            disabled={loading}>Αποθήκευση</Button>
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={7}>
                    <Alert variant={"secondary"}>
                        <strong>Οδηγίες συμπλήρωσης:</strong><br/>
                        - Όνομα Κανόνα: Το όνομα του κανόνα που επιθυμούμε. Αντίστοιχα θα είναι και το όνομα της στήλης
                        που παρουσιάζεται<br/>
                        - Κανόνες: Οι κανόνες που πρέπει να ακολουθούν οι λογαριασμοί που κινούνται έτσι ώστε να
                        υπολογιστούν σαν σύνολο<br/>
                        Κάθε κανόνας περιγράφει ένα άθροισμα. Έχει την μορφή λογαριασμού και μπορούν να συνδυαστούν
                        μεταξύ τους με απλές πράξεις.<br/>
                        Οι διαθέσιμες πράξεις είναι + και -<br/>
                        Η μορφή λογαριασμού έχει 3 κανόνες<br/>
                        - ΚΩΔΙΚΟΣ** : 2 αστέρια στο τέλος υποδηλώνει ότι θα θέλαμε να ξεκινά από τον κωδικό που του
                        δίνουμε <br/>
                        - **ΚΩΔΙΚΟΣ : 2 αστέρια στην αρχή υποδηλώνει ότι θα θέλαμε να τελειώνει στον κωδικό που του
                        δίνουμε <br/>
                        - **ΚΩΔΙΚΟΣ** : 2 αστέρια στην αρχή και 2 στο τέλος υποδηλώνει ότι θα θέλαμε να περιέχει τον
                        κωδικό που του δίνουμε <br/>
                        - ΚΩΔΙΚΟΣ : Χωρίς κανένα αστέρι υποδηλώνει ότι θα πρέπει να ισούται με τον κωδικό που του
                        δίνουμε <br/>
                        <strong>π.χ.</strong> Παράδειγμα απλού κανόνα αθροίσματος λογαριασμών που ξεκινούν από 60. :
                        60.** <br/>
                        <strong>π.χ.</strong> Παράδειγμα σύνθετου κανόνα που αφαιρεί από τους λογαριασμούς που ξεκινούν
                        από 6 τους λογαριασμούς που ξεκινούν από 4: <br/>6** - 4**<br/>
                    </Alert>
                </Col>
                <Col md={5}>
                    <Alert variant={"secondary"}>
                        Η στήλη "Πρόσημο" λαμβάνει δύο πιθανές τιμές, της χρέωσης ή της πίστωσης. Σε περίπτωση που το
                        υπόλοιπο βρίσκεται στην ίδια κατάσταση
                        με την επιλογή του πρόσημου τότε είναι θετικό, αλλιώς αρνητικό.<br/>
                        <strong>π.χ.</strong> Αν ένας λογαριασμός έχει υπόλοιπο ΧΡΕΩΣΗ 1300 και η επιλογή του πρόσημου
                        είναι ΠΙΣΤΩΣΗ τότε στα ετήσια αποτελέσματα υπολογίζεται ως -1300<br/>
                        <strong>π.χ.</strong> Αν ένας λογαριασμός έχει υπόλοιπο ΠΙΣΤΩΣΗ 300 και η επιλογή του πρόσημου
                        είναι ΠΙΣΤΩΣΗ τότε στα ετήσια αποτελέσματα υπολογίζεται ως 300
                    </Alert>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export const AccountingOperatingStatementRules = () => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);

    const defaultRules = {
        "1products": "",
        "1readyProducts": "",
        "1ab": "",
        "2products": "",
        "2readyProducts": "",
        "2ab": "",
        "3products": "",
        "3readyProducts": "",
        "3ab": "",
        "urgentIncome": "",
        "urgentExpenses": "",
    }
    const [rules, setRules] = useState({...defaultRules});

    useEffect(() => {
        fetchRules();
    }, [])

    const fetchRules = () => {
        setLoading(true);
        axios.get(process.env.REACT_APP_API_URL2 + "/accounting/get-operating-statement-rules", {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                if (Object.keys(res.data.data).length > 0) setRules(res.data.data);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
        })
    }

    const handleSave = () => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/accounting/save-operating-statement-rules", {
            company: company.id,
            rules: rules
        }, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Η αποθήκευση έγινε επιτυχώς.");
            } else {
                toast.success(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            <Row>
                <div className="text-muted mb-1"><i>Ομάδα 1. Αποθέματα ενάρξεως χρήσεως</i></div>
                <Col md={4}>
                    <Input
                        name={"1products"}
                        label={"Εμπορεύματα"}
                        value={rules["1products"]}
                        onChange={(e) => setRules({...rules, "1products": e.target.value})}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"1readyProducts"}
                        label={"Έτοιμα προϊόντα"}
                        value={rules["1readyProducts"]}
                        onChange={(e) => setRules({...rules, "1readyProducts": e.target.value})}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"1ab"}
                        label={"Α & Β ύλες - υλικά συσκευασίας"}
                        value={rules["1ab"]}
                        onChange={(e) => setRules({...rules, "1ab": e.target.value})}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <div className="text-muted mb-1"><i>Ομάδα 2. Αγορές Χρήσεως</i></div>
                <Col md={4}>
                    <Input
                        name={"2products"}
                        label={"Εμπορεύματα"}
                        value={rules["2products"]}
                        onChange={(e) => setRules({...rules, "2products": e.target.value})}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"2readyProducts"}
                        label={"Προϊόντα"}
                        value={rules["2readyProducts"]}
                        onChange={(e) => setRules({...rules, "2readyProducts": e.target.value})}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"2ab"}
                        label={"Α & Β ύλες - υλικά συσκευασίας"}
                        value={rules["2ab"]}
                        onChange={(e) => setRules({...rules, "2ab": e.target.value})}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <div className="text-muted mb-1"><i>Ομάδα 3. Μείον: Αποθέματα τέλους χρήσεως</i></div>
                <Col md={4}>
                    <Input
                        name={"3products"}
                        label={"Εμπορεύματα"}
                        value={rules["3products"]}
                        onChange={(e) => setRules({...rules, "3products": e.target.value})}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"3readyProducts"}
                        label={"Έτοιμα προϊόντα"}
                        value={rules["3readyProducts"]}
                        onChange={(e) => setRules({...rules, "3readyProducts": e.target.value})}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"3ab"}
                        label={"Α & Β ύλες - υλικά συσκευασίας"}
                        value={rules["3ab"]}
                        onChange={(e) => setRules({...rules, "3ab": e.target.value})}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <div className="text-muted mb-1"><i>Τελικά Αποτελέσματα</i></div>
                <Col md={4}>
                    <Input
                        name={"urgentIncome"}
                        label={"Έκτακτα έσοδα"}
                        value={rules["urgentIncome"]}
                        onChange={(e) => setRules({...rules, "urgentIncome": e.target.value})}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"urgentExpenses"}
                        label={"Έκτακτα έξοδα"}
                        value={rules["urgentExpenses"]}
                        onChange={(e) => setRules({...rules, "urgentExpenses": e.target.value})}
                    />
                </Col>
            </Row>
            <Row className={"mt-2 mb-2"}>
                <Col md={12}>
                    <Button size={"sm"} style={{float: "right"}} onClick={() => handleSave()}
                            disabled={loading}>Αποθήκευση</Button>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export const AccountingF2DocumentRules = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const activeAccordionKeys = useSelector((state) => state.ACCOUNTING_DATA.f2AccordionActiveKeys || []);
    const reduxClassicRules = useSelector((state) => state.ACCOUNTING_DATA.f2ClassicRules);
    const reduxCreationRules = useSelector((state) => state.ACCOUNTING_DATA.f2AccountingRecordCreationRules);
    const fetchDone = useSelector((state) => state.ACCOUNTING_DATA.f2RulesInitialFetchDone);
    const accountingRecordCategories = useSelector((state) => state.ACCOUNTING_DATA.accountingRecordCategories) || [];
    const accountingRecordSubcategories = useSelector((state) => state.ACCOUNTING_DATA.accountingRecordSubcategories) || [];

    const categoryOptions = [{
        label: "Κενό",
        value: ""
    }, ...getOptionsByData(accountingRecordCategories, "_id", "name")];
    const subCategoryOptions = [{
        label: "Κενό",
        value: ""
    }, ...getOptionsByData(accountingRecordSubcategories, "_id", "name")];

    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(!fetchDone);

    const defaultClassicRules = {
        "301": "", "331": "", "302": "", "332": "", "303": "", "333": "",
        "308": "", "338": "", "304": "", "334": "", "305": "", "335": "",
        "306": "", "336": "", "309": "", "339": "", "342": "", "345": "",
        "348": "", "349": "", "310": "", "313": "", "361": "", "381": "",
        "362": "", "382": "", "363": "", "383": "", "364": "", "384": "",
        "365": "", "385": "", "366": "", "386": "", "402": "", "407": "",
        "410": "", "411": "", "422": "", "423": "", "428": "",
        "906": "", "907": "", "908": "", "912": "",
        "507": "", "523": "2"
    };

    const defaultCreationRules = {
        accountingCategory: "",
        accountingSubCategory: "",
        tableData: []
    };

    const classicRules = reduxClassicRules || defaultClassicRules;
    const creationRules = reduxCreationRules || defaultCreationRules;

    const creationRulesRef = useRef(creationRules);
    useEffect(() => {
        creationRulesRef.current = creationRules;
    }, [creationRules]);

    useEffect(() => {
        if (company?.id) {
            dispatch(fetchAccountingRecordCategories(company.id));
            dispatch(fetchAccountingRecordSubcategories(company.id));
        }
    }, [company?.id, dispatch]);

    useEffect(() => {
        if (!fetchDone && company?.id) {
            fetchAllRules();
        } else {
            setInitialLoading(false);
        }
    }, [fetchDone, company?.id]);

    const fetchAllRules = () => {
        setInitialLoading(true);
        Promise.all([
            axios.get(process.env.REACT_APP_API_URL2 + "/accounting/get-f2-rules", {
                headers: {"Content-Type": "application/json"},
                params: {company: company.id}
            }),
            axios.get(process.env.REACT_APP_API_URL2 + "/accounting/get-accounting-record-rules", {
                headers: {"Content-Type": "application/json"},
                params: {company: company.id}
            })
        ]).then(([f2Res, recordRulesRes]) => {
            setInitialLoading(false);

            if (f2Res.data.status === "200" && f2Res.data.data) {
                const fetchedRules = {...defaultClassicRules};
                Object.keys(f2Res.data.data).forEach(key => {
                    if (defaultClassicRules[key] !== undefined) {
                        fetchedRules[key] = f2Res.data.data[key];
                    }
                });
                if (!fetchedRules["523"]) fetchedRules["523"] = "2";
                dispatch(setF2ClassicRules(fetchedRules));
            }

            if (recordRulesRes.data.status === "200") {
                if (recordRulesRes.data.data && Object.keys(recordRulesRes.data.data).length > 0) {
                    dispatch(setF2AccountingRecordCreationRules({
                        ...defaultCreationRules,
                        ...recordRulesRes.data.data
                    }));
                } else {
                    dispatch(setF2AccountingRecordCreationRules(defaultCreationRules));
                }
            }

            dispatch(setF2RulesInitialFetchDone(true));
        }).catch((err) => {
            setInitialLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την ανάκτηση των κανόνων.");
        });
    };

    const handleSaveAll = () => {
        setLoading(true);
        Promise.all([
            axios.post(process.env.REACT_APP_API_URL2 + "/accounting/save-f2-rules", {
                company: company.id,
                rules: classicRules
            }, {
                headers: {"Content-Type": "application/json"}
            }),
            axios.post(process.env.REACT_APP_API_URL2 + "/accounting/save-accounting-record-rules", {
                company: company.id,
                accountingRecordCreationRules: creationRulesRef.current
            }, {
                headers: {"Content-Type": "application/json"}
            })
        ]).then(([f2Res, recordRulesRes]) => {
            setLoading(false);
            if (f2Res.data.status === "200" && recordRulesRes.data.status === "200") {
                toast.success("Όλοι οι κανόνες αποθηκεύτηκαν επιτυχώς.");
            } else {
                toast.warning("Κάποιοι κανόνες ενδέχεται να μην αποθηκεύτηκαν σωστά.");
            }
        }).catch((err) => {
            setLoading(false);
            toast.error("Σφάλμα κατά την αποθήκευση των κανόνων.");
            console.log(err);
        });
    };

    const handleClassicChange = (code, val) => {
        dispatch(setF2ClassicRules({...classicRules, [code]: val}));
    };

    const handleCreationRuleChange = (e, name) => {
        dispatch(setF2AccountingRecordCreationRules({...creationRulesRef.current, [name]: e.value}));
    };

    const handleAccordionToggle = (selectedKeys) => {
        const keysArray = Array.isArray(selectedKeys) ? selectedKeys : (selectedKeys ? [selectedKeys] : []);
        dispatch(setF2AccordionActiveKeys(keysArray));
    };

    const tableColumns = [
        {name: "Α/Α", field: "no", editable: false, width: "5%"},
        {name: "Όνομα Κανόνα", field: "ruleName", editable: true, width: "25%", inputType: {type: "input"}},
        {name: "Κανόνες", field: "rules", editable: true, width: "55%", inputType: {type: "input"}},
        {
            name: "Πρόσημο", field: "sign", editable: true, width: "15%", inputType: {
                type: "select",
                options: [{label: "Πίστωση", value: "credit"}, {label: "Χρέωση", value: "debit"}]
            }
        }
    ];

    const tableFunctions = {
        insert: (e, data) => {
            const currentRules = creationRulesRef.current;
            if (!isEmpty(data.value)) {
                let cloneTableData = structuredClone(currentRules.tableData || []);
                let initRow = {
                    no: String(cloneTableData.length + 1),
                    ruleName: "",
                    rules: "",
                    sign: "credit",
                };
                initRow = {...initRow, [data.field]: data.value};
                cloneTableData.push(initRow);
                dispatch(setF2AccountingRecordCreationRules({...currentRules, tableData: cloneTableData}));
            }
        },
        update: (data, id, rowIndex) => {
            const currentRules = creationRulesRef.current;
            let cloneTableData = structuredClone(currentRules.tableData || []);
            cloneTableData[rowIndex] = {...cloneTableData[rowIndex], ...data};
            dispatch(setF2AccountingRecordCreationRules({...currentRules, tableData: cloneTableData}));
        },
        selected: () => {
        },
        delete: (id, rowIndex) => {
            const currentRules = creationRulesRef.current;
            let cloneTableData = structuredClone(currentRules.tableData || []);
            cloneTableData.splice(rowIndex, 1);
            cloneTableData = cloneTableData.map((row, idx) => ({...row, no: String(idx + 1)}));
            dispatch(setF2AccountingRecordCreationRules({...currentRules, tableData: cloneTableData}));
        }
    };

    const renderInput = (code, label) => (
        <div className="form-group mb-2">
            <label className="mb-1 d-block">{label}</label>
            <Form.Control
                size="sm"
                type="text"
                value={classicRules[code] || ""}
                onChange={(e) => handleClassicChange(code, e.target.value)}
            />
        </div>
    );

    if (initialLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5">
                <span className="text-muted fst-italic">Φόρτωση Κανόνων...</span>
            </div>
        );
    }

    return (
        <React.Fragment>
            <style>{`
                .f2-accordion .accordion-button:not(.collapsed) {
                    background-color: #f8f9fa !important;
                    color: #76AEB7 !important;
                    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125) !important;
                }
                .f2-accordion .accordion-button:focus {
                    border-color: #76AEB7 !important;
                    box-shadow: 0 0 0 0.25rem rgba(118, 174, 183, 0.25) !important;
                }
                .f2-accordion .accordion-button:not(.collapsed)::after {
                    filter: none !important;
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2376AEB7'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
                }
            `}</style>

            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="text-muted"><i>Ρυθμίσεις & Κανόνες Εντύπου Φ2 και Δημιουργίας Εγγραφών</i></div>
            </div>

            <Accordion
                alwaysOpen
                activeKey={activeAccordionKeys}
                onSelect={handleAccordionToggle}
                className="mb-3 f2-accordion"
            >
                <Accordion.Item eventKey="0" className="mb-2 border">
                    <Accordion.Header>
                        <span className="font-weight-bold">Β. ΠΙΝΑΚΑΣ ΕΚΡΟΩΝ - ΕΙΣΡΟΩΝ</span>
                    </Accordion.Header>
                    <Accordion.Body className="p-3">
                        <Row>
                            <Col lg={6} className="border-right">
                                <div className="font-weight-bold mb-2 border-bottom pb-1">α) ΕΚΡΟΕΣ & ΦΟΡΟΣ ΕΚΡΟΩΝ</div>
                                <div className="text-muted d-block mb-1 fst-italic">I. Λοιπή Ελλάδα</div>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("301", "301 - Εκροές 13%")}</Col>
                                    <Col md={6}>{renderInput("331", "331 - Φόρος 13%")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("302", "302 - Εκροές 6%")}</Col>
                                    <Col md={6}>{renderInput("332", "332 - Φόρος 6%")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("303", "303 - Εκροές 24%")}</Col>
                                    <Col md={6}>{renderInput("333", "333 - Φόρος 24%")}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col md={6}>{renderInput("308", "308 - Εκροές 4%")}</Col>
                                    <Col md={6}>{renderInput("338", "338 - Φόρος 4%")}</Col>
                                </Row>

                                <div className="text-muted d-block mb-1 fst-italic">II. Νησιά Αιγαίου</div>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("304", "304 - Εκροές 9%")}</Col>
                                    <Col md={6}>{renderInput("334", "334 - Φόρος 9%")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("305", "305 - Εκροές 4%")}</Col>
                                    <Col md={6}>{renderInput("335", "335 - Φόρος 4%")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("306", "306 - Εκροές 17%")}</Col>
                                    <Col md={6}>{renderInput("336", "336 - Φόρος 17%")}</Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6}>{renderInput("309", "309 - Εκροές 3%")}</Col>
                                    <Col md={6}>{renderInput("339", "339 - Φόρος 3%")}</Col>
                                </Row>

                                <div className="text-muted d-block mb-1 fst-italic">Λοιπές Πράξεις / Απαλλαγές</div>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("342", "342 - Ενδοκοινοτικές Παραδόσεις")}</Col>
                                    <Col md={6}>{renderInput("345", "345 - Ενδοκ. Παροχές Υπηρεσιών")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("348", "348 - Εξαγωγές & Απαλλαγές")}</Col>
                                    <Col md={6}>{renderInput("349", "349 - Λοιπές Εκροές με δικ. έκπτωσης")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("310", "310 - Εκροές χωρίς δικ. έκπτωσης")}</Col>
                                    <Col md={6}>{renderInput("313", "313 - Λοιπές πράξεις εκτός Κ.Ε. ΦΠΑ")}</Col>
                                </Row>
                            </Col>

                            <Col lg={6}>
                                <div className="font-weight-bold mb-2 border-bottom pb-1">β) ΕΙΣΡΟΕΣ & ΦΟΡΟΣ ΕΙΣΡΟΩΝ
                                </div>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("361", "361 - Αγορές & Δαπάνες Εσωτερικού")}</Col>
                                    <Col md={6}>{renderInput("381", "381 - Φόρος Αγορών & Δαπανών")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("362", "362 - Αγορές & Εισαγωγές Παγίων")}</Col>
                                    <Col md={6}>{renderInput("382", "382 - Φόρος Επενδυτικών (Παγίων)")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("363", "363 - Λοιπές Εισαγωγές εκτός Παγίων")}</Col>
                                    <Col md={6}>{renderInput("383", "383 - Φόρος Λοιπών Εισαγωγών")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("364", "364 - Ενδοκοινοτικές Αποκτήσεις Αγαθών")}</Col>
                                    <Col md={6}>{renderInput("384", "384 - Φόρος Ενδοκ. Αποκτήσεων")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("365", "365 - Ενδοκοινοτικές Λήψεις Υπηρεσιών")}</Col>
                                    <Col md={6}>{renderInput("385", "385 - Φόρος Ενδοκ. Λήψεων Υπηρεσιών")}</Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6}>{renderInput("366", "366 - Λοιπές Πράξεις Λήπτη")}</Col>
                                    <Col md={6}>{renderInput("386", "386 - Φόρος Λοιπών Πράξεων Λήπτη")}</Col>
                                </Row>

                                <div className="font-weight-bold mb-2 border-bottom pb-1">δ) ΠΡΟΣΤΙΘΕΜΕΝΑ ΠΟΣΑ (+), ε)
                                    ΑΦΑΙΡΟΥΜΕΝΑ ΠΟΣΑ (-)
                                </div>
                                <Row className="mb-1">
                                    <Col md={6}>{renderInput("402", "402 - Λοιπά Προστιθέμενα Ποσά")}</Col>
                                    <Col md={6}>{renderInput("407", "407 - Διακανονισμοί προς έκπτωση")}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col md={12}>{renderInput("410", "410 - ΣΥΝΟΛΟ ΠΡΟΣΤΙΘΕΜΕΝΩΝ (+)")}</Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col md={4}>{renderInput("411", "411 - Μείωση ProRata")}</Col>
                                    <Col md={4}>{renderInput("422", "422 - Λοιπά Αφαιρούμενα")}</Col>
                                    <Col md={4}>{renderInput("423", "423 - Διακαν. προς καταβολή")}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col md={12}>{renderInput("428", "428 - ΣΥΝΟΛΟ ΑΦΑΙΡΟΥΜΕΝΩΝ (-)")}</Col>
                                </Row>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1" className="mb-2 border">
                    <Accordion.Header>
                        <span className="font-weight-bold">Γ. ΠΙΝΑΚΑΣ ΕΚΚΑΘΑΡΙΣΗΣ ΤΟΥ ΦΟΡΟΥ</span>
                    </Accordion.Header>
                    <Accordion.Body className="p-3">
                        <Row>
                            <Col md={6}>
                                <div className="form-group mb-2">
                                    <label className="mb-1 d-block">523 - Προεπιλογή για Καταβολή σε Δόσεις</label>
                                    <Form.Control
                                        as="select"
                                        size="sm"
                                        value={classicRules["523"] || "2"}
                                        onChange={(e) => handleClassicChange("523", e.target.value)}
                                    >
                                        <option value="2">ΟΧΙ (Προεπιλογή)</option>
                                        <option value="1">ΝΑΙ</option>
                                    </Form.Control>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group mb-2">
                                    <label className="mb-1 d-block">507 - Προεπιλογή για Αιτία Επιστροφής</label>
                                    <Form.Control
                                        as="select"
                                        size="sm"
                                        value={classicRules["507"] || ""}
                                        onChange={(e) => handleClassicChange("507", e.target.value)}
                                    >
                                        <option value="">Καμία Επιλογή</option>
                                        <option value="1">1 - Απαλλασσόμενες Πράξεις</option>
                                        <option value="2">2 - Πάγια</option>
                                        <option value="3">3 - Αναστολή Καταβολής</option>
                                        <option value="4">4 - Διαφορά Συντελεστών</option>
                                        <option value="5">5 - Άλλη Αιτία</option>
                                        <option value="6">6 - Μείωση Χρεωστικού Υπολοίπου</option>
                                    </Form.Control>
                                </div>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2" className="mb-2 border">
                    <Accordion.Header>
                        <span className="font-weight-bold">ΠΛΗΡΟΦΟΡΙΑΚΑ ΣΤΟΙΧΕΙΑ</span>
                    </Accordion.Header>
                    <Accordion.Body className="p-3">
                        <Row>
                            <Col md={3}>{renderInput("906", "906 - Πωλήσεις α' κατοικίας")}</Col>
                            <Col md={3}>{renderInput("907", "907 - Αξία εισροών κωδ. 906")}</Col>
                            <Col md={3}>{renderInput("908", "908 - Μικτό κέρδος επιχ. άρθρου 50")}</Col>
                            <Col md={3}>{renderInput("912", "912 - Απαλλ/νες πράξεις Αγίου Όρους")}</Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3" className="mb-2 border">
                    <Accordion.Header>
                        <span className="font-weight-bold">ΚΑΝΟΝΕΣ ΔΗΜΙΟΥΡΓΙΑΣ ΛΟΓΙΣΤΙΚΗΣ ΕΓΓΡΑΦΗΣ</span>
                    </Accordion.Header>
                    <Accordion.Body className="p-3">
                        <Row className="mb-4">
                            <Col md={4}>
                                <Dropdown
                                    name="accountingCategory"
                                    options={categoryOptions}
                                    label="Λογιστική Κατηγορία"
                                    defaultValue={categoryOptions.find((el) => el.value === creationRules.accountingCategory) || undefined}
                                    required={true}
                                    onChange={(e) => handleCreationRuleChange(e, "accountingCategory")}
                                />
                            </Col>
                            <Col md={4}>
                                <Dropdown
                                    name="accountingSubCategory"
                                    options={subCategoryOptions}
                                    label="Λογιστική Υποκατηγορία"
                                    defaultValue={subCategoryOptions.find((el) => el.value === creationRules.accountingSubCategory) || undefined}
                                    required={true}
                                    onChange={(e) => handleCreationRuleChange(e, "accountingSubCategory")}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <EditableTable
                                    tableName="Accounting Creation Rules Table"
                                    key={Math.random()}
                                    data={creationRules.tableData || []}
                                    columns={tableColumns}
                                    onUpdate={tableFunctions}
                                    allowInsertRow={true}
                                    allowActions={true}
                                />
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Row className="mt-2 mb-3">
                <Col md={12}>
                    <Button size="sm" style={{float: "right"}} onClick={handleSaveAll} disabled={loading}>
                        {loading ? "Αποθήκευση..." : "Αποθήκευση"}
                    </Button>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export const AccountingIncomeExpenseBookSettings = () => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const {t} = useTranslation();

    useEffect(() => {
        fetchIERules();
    }, [])

    const bookOptions = [
        {label: "Βιβλίο εσόδων", value: "income"},
        {label: "Βιβλίο εξόδων", value: "expense"},
    ]

    const tableColumns = [
        {
            name: t("General.no"),
            field: "no",
            editable: false,
            width: "5%"
        },
        {
            name: "Τύπος Βιβλίου",
            field: "bookOption",
            editable: true,
            width: "15%",
            inputType: {
                type: "select",
                options: bookOptions,
            }
        },
        {
            name: t("General.ruleName"),
            field: "ruleName",
            editable: true,
            width: "25%",
            inputType: {
                type: "input"
            }
        },
        {
            name: t("General.rules"),
            field: "rules",
            editable: true,
            width: "40%",
            inputType: {
                type: "input"
            }
        },
        {
            name: "Πρόσημο",
            field: "sign",
            editable: true,
            width: "15%",
            inputType: {
                type: "select",
                options: [{label: "Πίστωση", value: "credit"}, {label: "Χρέωση", value: "debit"}]
            }
        }
    ]

    const fetchIERules = () => {
        setLoading(true);
        axios.get(process.env.REACT_APP_API_URL2 + "/accounting/get-ie-rules", {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                setTableData(res.data.data);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
        })
    }

    const handleSave = () => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/accounting/save-ie-rules", {
            company: company.id,
            incomeExpenseBookRules: tableData
        }, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Η αποθήκευση έγινε επιτυχώς.");
            } else {
                toast.success(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }

    const tableFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value)) {
                let cloneTableData = structuredClone(tableData);
                let initRow = {
                    no: String(tableData.length + 1),
                    bookOption: "income",
                    ruleName: "",
                    rules: "",
                    sign: "credit",
                }
                initRow = {...initRow, [data.field]: data.value};
                cloneTableData.push(initRow);
                setTableData(cloneTableData);
            }
        },
        update: (data, id, rowIndex) => {
            let cloneTableData = structuredClone(tableData);
            cloneTableData[rowIndex] = {...cloneTableData[rowIndex], ...data};
            setTableData(cloneTableData);
        },
        selected: () => {
        },
        delete: (id, rowIndex) => {
            let cloneTableData = structuredClone(tableData);
            cloneTableData.splice(rowIndex, 1);
            setTableData(cloneTableData);
        }
    }

    return (
        <React.Fragment>
            <Row>
                <div className="text-muted mb-1"><i>Κανόνες Βιβλίου Εσόδων/Εξόδων</i></div>
                <Col md={12}>
                    <EditableTable
                        tableName={"Accounting IE Book Rules"}
                        key={Math.random()}
                        data={tableData}
                        columns={tableColumns}
                        onUpdate={tableFunctions}
                        allowInsertRow={true}
                        allowActions={true}
                    />
                    <Button size={"sm"} style={{float: "right"}} onClick={() => handleSave()}
                            disabled={loading}>Αποθήκευση</Button>
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={7}>
                    <Alert variant={"secondary"}>
                        <strong>Οδηγίες συμπλήρωσης:</strong><br/>
                        - Όνομα Κανόνα: Το όνομα του κανόνα που επιθυμούμε. Αντίστοιχα θα είναι και το όνομα της στήλης
                        που παρουσιάζεται<br/>
                        - Κανόνες: Οι κανόνες που πρέπει να ακολουθούν οι λογαριασμοί που κινούνται έτσι ώστε να
                        υπολογιστούν σαν σύνολο<br/>
                        Κάθε κανόνας περιγράφει ένα άθροισμα. Έχει την μορφή λογαριασμού και μπορούν να συνδυαστούν
                        μεταξύ τους με απλές πράξεις.<br/>
                        Οι διαθέσιμες πράξεις είναι + και -<br/>
                        Η μορφή λογαριασμού έχει 3 κανόνες<br/>
                        - ΚΩΔΙΚΟΣ** : 2 αστέρια στο τέλος υποδηλώνει ότι θα θέλαμε να ξεκινά από τον κωδικό που του
                        δίνουμε <br/>
                        - **ΚΩΔΙΚΟΣ : 2 αστέρια στην αρχή υποδηλώνει ότι θα θέλαμε να τελειώνει στον κωδικό που του
                        δίνουμε <br/>
                        - **ΚΩΔΙΚΟΣ** : 2 αστέρια στην αρχή και 2 στο τέλος υποδηλώνει ότι θα θέλαμε να περιέχει τον
                        κωδικό που του δίνουμε <br/>
                        - ΚΩΔΙΚΟΣ1**ΚΩΔΙΚΟΣ2 : 2 αστέρια στο ενδιάμεσο υποδηλώνει ότι θα θέλαμε να ξεκινά από τον
                        ΚΩΔΙΚΟΣ1 και να τελειώνει στον ΚΩΔΙΚΟΣ2 <br/>
                        - ΚΩΔΙΚΟΣ : Χωρίς κανένα αστέρι υποδηλώνει ότι θα πρέπει να ισούται με τον κωδικό που του
                        δίνουμε <br/>
                        <strong>π.χ.</strong> Παράδειγμα απλού κανόνα αθροίσματος λογαριασμών που ξεκινούν από 60. :
                        60.** <br/>
                        <strong>π.χ.</strong> Παράδειγμα σύνθετου κανόνα που αφαιρεί από τους λογαριασμούς που ξεκινούν
                        από 6 τους λογαριασμούς που ξεκινούν από 4: <br/>6** - 4**<br/>
                    </Alert>
                </Col>
                <Col md={5}>
                    <Alert variant={"secondary"}>
                        Η στήλη "Πρόσημο" λαμβάνει δύο πιθανές τιμές, της χρέωσης ή της πίστωσης. Σε περίπτωση που το
                        υπόλοιπο βρίσκεται στην ίδια κατάσταση
                        με την επιλογή του πρόσημου τότε είναι θετικό, αλλιώς αρνητικό.<br/>
                        <strong>π.χ.</strong> Αν ένας λογαριασμός έχει υπόλοιπο ΧΡΕΩΣΗ 1300 και η επιλογή του πρόσημου
                        είναι ΠΙΣΤΩΣΗ τότε στα ετήσια αποτελέσματα υπολογίζεται ως -1300<br/>
                        <strong>π.χ.</strong> Αν ένας λογαριασμός έχει υπόλοιπο ΠΙΣΤΩΣΗ 300 και η επιλογή του πρόσημου
                        είναι ΠΙΣΤΩΣΗ τότε στα ετήσια αποτελέσματα υπολογίζεται ως 300
                    </Alert>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export const AccountingSettingsLog = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.accountingSettingsLog')}</i></div>
            <LogTable model="accountingSetting"/>
        </React.Fragment>
    )
}
